// Before this date all streams are considered delivered if they lasted more than 0 minutes
export const NEW_STREAMS_MIN_THRESHOLD_POLICY_DATE = '2025-03-11T00:00:00Z';
export const LEADERBOARD_FROM_LAST_DAYS = 90;
export const LEADERBOARD_LIMIT = 50;
export var RankingType;
(function (RankingType) {
    RankingType["DropCompletedFromAllTime"] = "dropCompletedFromAllTime";
    RankingType["DropsCompletedFrom90Days"] = "dropsCompletedFrom90Days";
    RankingType["ClicksRate"] = "clicksRate";
})(RankingType || (RankingType = {}));
